// frontend-vite/src/authConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

// Normalize redirect base with trailing slash and log for diagnostics
// Normalize redirect base with trailing slash
const redirectBase = window.location.origin.endsWith("/")
  ? window.location.origin
  : `${window.location.origin}/`;

export const msalConfig = {
  auth: {
    clientId: "8d41e9b8-8194-440a-a349-cef9269ed564",
    authority: "https://login.microsoftonline.com/bd262270-d3d4-4e69-8eab-ec0eaec24f0f",
    // Use current origin for both local dev and deployed environments
    redirectUri: redirectBase,
    postLogoutRedirectUri: redirectBase,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// ✅ Add permission scopes here
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "offline_access",
    "User.Read"
  ],
};

// ✅ Export msalInstance here
export const msalInstance = new PublicClientApplication(msalConfig);




// // frontend-vite/src/authConfig.js

// export const msalConfig = {
//   auth: {
//     clientId: "9dd89cc2-2f36-4503-9608-dbb007354b67",
//     authority: "https://login.microsoftonline.com/bd262270-d3d4-4e69-8eab-ec0eaec24f0f",
//     redirectUri: "http://localhost:5173/",
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: false,
//   },
// };

// // ✅ Add permission scopes here
// export const loginRequest = {
//   scopes: [
//     "User.Read",
//     "Mail.Send",              // ✅ Required to send emails
//     "Mail.ReadWrite",         // Optional: lets you read/write to the mailbox
//     "offline_access"          // Optional: allows refresh tokens
//   ],
// };
